import API from "./axios";

export const getITRs = async () => {
  try {
    const response = await API.get("/itr");
    return response.data;
  } catch (error) {
    throw error.response.data.message || "Failed to fetch ITR applications";
  }
};

export const updateITR = async (id, itrData) => {
  try {
    const response = await API.put(`/itr/${id}`, itrData);
    return response.data;
  } catch (error) {
    throw error.response.data.message || "Failed to update ITR";
  }
};

export const createITR = async (customerId, asstYear, status = 'Pending') => {
  try {
    const response = await API.post("/itr", { customer_id: customerId, asst_year: asstYear, status });
    return response.data;
  } catch (error) {
    throw error.response.data.message || "Failed to create ITR";
  }
};

export const reapply = async (itrId) => {
  try {
    const response = await API.post("/itr/reapply", { itrId });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to reapply";
  }
};

export const reapplyWithWallet = async (itrId) => {
  try {
    const response = await API.post("/itr/reapply-with-wallet", { itrId });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to reapply with wallet";
  }
};
